export default {
  PAGINATION: {
    PER_PAGE: 10,
  },
};
